// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 36 37"
    {...props}
  >
    <path
      fill="#fff"
      d="M4 15.9846C4 13.7444 4 12.6243 4.43597 11.7687C4.81947 11.016 5.43139 10.4041 6.18404 10.0206C7.03969 9.58464 8.15979 9.58464 10.4 9.58464H21.6C23.8402 9.58464 24.9603 9.58464 25.816 10.0206C26.5686 10.4041 27.1805 11.016 27.564 11.7687C28 12.6243 28 13.7444 28 15.9846V27.1846C28 29.4248 28 30.545 27.564 31.4006C27.1805 32.1532 26.5686 32.7652 25.816 33.1487C24.9603 33.5846 23.8402 33.5846 21.6 33.5846H10.4C8.15979 33.5846 7.03969 33.5846 6.18404 33.1487C5.43139 32.7652 4.81947 32.1532 4.43597 31.4006C4 30.545 4 29.4248 4 27.1846V15.9846Z"
    />
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M28 17.5846H4M21.3333 6.91797V12.2513M10.6667 6.91797V12.2513M10.4 33.5846H21.6C23.8402 33.5846 24.9603 33.5846 25.816 33.1487C26.5686 32.7652 27.1805 32.1532 27.564 31.4006C28 30.545 28 29.4248 28 27.1846V15.9846C28 13.7444 28 12.6243 27.564 11.7687C27.1805 11.016 26.5686 10.4041 25.816 10.0206C24.9603 9.58464 23.8402 9.58464 21.6 9.58464H10.4C8.15979 9.58464 7.03969 9.58464 6.18404 10.0206C5.43139 10.4041 4.81947 11.016 4.43597 11.7687C4 12.6243 4 13.7444 4 15.9846V27.1846C4 29.4248 4 30.545 4.43597 31.4006C4.81947 32.1532 5.43139 32.7652 6.18404 33.1487C7.03969 33.5846 8.15979 33.5846 10.4 33.5846Z"
    />
    <circle
      cx={27}
      cy={9.25}
      r={8}
      fill="#6421B9"
      stroke="#fff"
      strokeWidth={2}
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M27 6.25V9.25V12.25M24 9.25H30"
    />
  </svg>
);
const IconAddInterviewToCalendar = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconAddInterviewToCalendar;
